import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { IDepartment, User } from "@app/shared/models/user";
import { LocalStorageService } from "@app/shared/services/local-storage-service";
import { SharedDataService } from "@app/shared/services/shared-data.service";
import { UserSubscriber } from "@app/shared/subscribers/user.subscriber";
import { Subscription } from "rxjs";

@Component({
  selector: "db-department-menu",
  templateUrl: "./department-menu.component.html",
  styleUrls: ["./department-menu.component.scss"]
})
export class DepartmentMenuComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  user = new User();

  constructor(
    private _userSubscriber: UserSubscriber,
    private _localStorageService: LocalStorageService,
    private _router: Router,
    private _sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.subscription.add(this.subscribeToUser());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeToUser(): Subscription {
    return this._userSubscriber.user$.subscribe({
      next: (user: User) => {
        this.user = user;
      },
    })
  }

  isCurrentDepartment(department: string): boolean {
    return this.user.selectedDepartment === department;
  }

  setDepartment(department: IDepartment): void {
    if (this.isCurrentDepartment(department.department)) return;
    this.setDepartmentInSubscriber(department);

    this._localStorageService.setItem('selectedDepartment', department.department);
    this._localStorageService.setItem('theme', department.theme);
    this._sharedDataService.userIsAdmin = department.isAdmin;

    this._router.navigate(['main']).then(() => {
      window.location.reload();
    });
  }

  private setDepartmentInSubscriber(department: IDepartment): void {
    this._userSubscriber.setSelectedDepartment(department.department);
  }
}
